import "./index.css";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { reportGlobalError } from "./utils/errorReporting";
import { logger } from "utils/logger";
import { initCrashlytics } from "./firebase/crashlytics";
import { ensureServiceWorkerRegistered } from "./serviceWorkerRegister";

// Leaflet is now loaded dynamically in CoffeeMap component
// This reduces initial bundle size by ~150KB

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
  </React.StrictMode>,
);

// Defer crash reporting initialization until after initial render
// This keeps Firebase off the critical path for better Lighthouse scores
if ("requestIdleCallback" in window) {
  (window as any).requestIdleCallback(() => initCrashlytics());
} else {
  setTimeout(() => initCrashlytics(), 1000);
}

// Service Worker: register in prod, unregister in dev to prevent HMR issues
ensureServiceWorkerRegistered();

// DO NOT preload Firebase - let it load on-demand when user authenticates
// This keeps the initial bundle small and improves Lighthouse performance
// if ("requestIdleCallback" in window) {
//   (window as any).requestIdleCallback(() => import("./firebase"));
// } else {
//   setTimeout(() => import("./firebase"), 0);
// }

window.addEventListener("unhandledrejection", (event) => {
  reportGlobalError(event.reason);
});

window.onerror = (
  message: string | Event,
  source?: string,
  lineno?: number,
  colno?: number,
  error?: Error,
) => {
  const details = { message, source, lineno, colno, error };
  reportGlobalError(error || message, details);
};
